import { ICheckTypes, ISingleCheckType } from "@schemas/checklistSchema";
import { Alert, Button, Checkbox, Group, Stack } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import * as R from "ramda";
import React from "react";
import McInputNew from "../../../components/McInput/McInputNew";

const CheckTypesSelector: React.FC<{
  onChange: (types: ICheckTypes) => void;
  checkTypes: ICheckTypes;
  disabled?: boolean;
  inputIsEditable: boolean;
}> = ({ onChange: setCheckTypes, checkTypes, disabled, inputIsEditable }) => {
  const [showMore, setShowMore] = React.useState<boolean>(false);

  const extraTypes = removeChecklistType123(checkTypes);

  return (
    <Stack gap="xs">
      <SingleChecklistType
        disabled={true}
        inputIsEditable={inputIsEditable}
        checklistType={checkTypes.check1}
        onChecklistTypeChanged={(checklistType) => setCheckTypes({ ...checkTypes, check1: checklistType })}
      />
      <SingleChecklistType
        disabled={false}
        inputIsEditable={inputIsEditable}
        checklistType={checkTypes.check2}
        onChecklistTypeChanged={(checklistType) => setCheckTypes({ ...checkTypes, check2: checklistType })}
      />
      <SingleChecklistType
        disabled={false}
        inputIsEditable={inputIsEditable}
        checklistType={checkTypes.check3}
        onChecklistTypeChanged={(checklistType) => setCheckTypes({ ...checkTypes, check3: checklistType })}
      />

      <div>
        <Button variant="subtle" size="sm" onClick={() => setShowMore(!showMore)}>
          {showMore === true ? "-Vis færre" : "+Vis flere"}
        </Button>
      </div>

      {showMore === true && (
        <Stack gap="xs">
          <Alert variant="light" color="blue" p={"xs"} icon={<IconInfoCircle size={20} />}>
            OBS! Disse rollene kommer ikke med i generert utskrift
          </Alert>
          {Object.keys(extraTypes).map((key) => (
            <SingleChecklistType
              key={key}
              disabled={false}
              inputIsEditable={inputIsEditable}
              checklistType={checkTypes[key as keyof ICheckTypes]}
              onChecklistTypeChanged={(checklistType) => setCheckTypes({ ...checkTypes, [key]: checklistType })}
            />
          ))}
        </Stack>
      )}
    </Stack>
  );
};

const removeChecklistType123 = (checkTypes: ICheckTypes) => {
  let newCheckTypes = R.clone(checkTypes);
  delete newCheckTypes.check1;
  delete newCheckTypes.check2;
  delete newCheckTypes.check3;

  //Add checks here if needed

  return newCheckTypes;
};

export default CheckTypesSelector;

const SingleChecklistType: React.FC<{
  inputIsEditable: boolean;
  disabled: boolean;
  checklistType: ISingleCheckType;
  onChecklistTypeChanged: (checklisType: ISingleCheckType) => void;
}> = ({ inputIsEditable, disabled, checklistType, onChecklistTypeChanged }) => {
  return (
    <Group wrap="nowrap" align="center" gap="xs">
      <Checkbox
        size="sm"
        checked={checklistType.active}
        onChange={() => onChecklistTypeChanged({ ...checklistType, active: !checklistType.active })}
        disabled={disabled}
        label={inputIsEditable === false ? checklistType.name : undefined}
      />
      {inputIsEditable === true && (
        <McInputNew
          required={true}
          disabled={checklistType.active === false}
          value={checklistType.name}
          onBlur={(e) => onChecklistTypeChanged({ ...checklistType, name: e.target.value })}
        />
      )}
    </Group>
  );
};
